import {showSuccess, showError} from "../utils/msg";
import qs from "qs";

import {
  TOGGLE_SIDEBAR,
  REQUEST_INVITE_INFO,
  RECEIVE_INVITE_INFO,
  REQUEST_SP_INFO,
  RECEIVE_SP_INFO,
  RECEIVE_SAVE_SP_INFO,
  REQUEST_SAVE_SP_INFO,
  UPDATE_INFO_CONTACTOR,
  UPDATE_INFO_NAME,
  UPDATE_WECHAT_APP_ID,
  UPDATE_WECHAT_APP_SECRET,
  UPDATE_WECHAT_ENCODING_AES_KEY,
  REQUEST_WECHAT_INFO,
  RECEIVE_WECHAT_INFO,
  REQUEST_WECHAT_CLEAR_SETTING,
  RECEIVE_WECHAT_CLEAR_SETTING,
  REQUEST_SAVE_WECHAT_INFO,
  RECEIVE_SAVE_WECHAT_INFO,
  REQUEST_SAVE_FORM_INFO,
  RECEIVE_SAVE_FORM_INFO,
  REQUEST_FORM_LIST,
  RECEIVE_FORM_LIST,
  REQUEST_SHARED_FORM_LIST,
  RECEIVE_SHARED_FORM_LIST,
  REQUEST_FORM_INFO,
  RECEIVE_FORM_INFO,
  REQUEST_DEFAULT_FORM_INFO,
  RECEIVE_DEFAULT_FORM_INFO,
  REQUEST_MY_TICKET_LIST,
  RECEIVE_MY_TICKET_LIST,
  REQUEST_TICKET_DETAIL,
  RECEIVE_TICKET_DETAIL,
  REQUEST_CHANGE_PASSWORD,
  RECEIVE_CHANGE_PASSWORD,
  REQUEST_CREATE_WECHAT_MENU,
  RECEIVE_CREATE_WECHAT_MENU,
  REQUEST_BIND_YHL_TEAM,
  RECEIVE_BIND_YHL_TEAM,
  REQUEST_APPLY_SUB_DOMAIN,
  RECEIVE_APPLY_SUB_DOMAIN,
  REQUEST_SUBDOMAIN_LIST,
  RECEIVE_SUBDOMAIN_LIST,
  REQUEST_ACCOUNT_INFO,
  RECEIVE_ACCOUNT_INFO,
  REQUEST_ACCOUNT_RENEW,
  RECEIVE_ACCOUNT_RENEW,
  REQUEST_ACCOUNT_SZ_LIST,
  RECEIVE_ACCOUNT_SZ_LIST,
  REQUEST_SP_LIST,
  RECEIVE_SP_LIST,
  REQUEST_FETCH_WECHAT_MENU,
  RECEIVE_FETCH_WECHAT_MENU,
  REQUEST_SP_SETTING,
  RECEIVE_SP_SETTING,
  REQUEST_SAVE_SP_SETTING,
  RECEIVE_SAVE_SP_SETTING,
  REQUEST_FETCH_AUTHORIZER_LIST,
  RECEIVE_FETCH_AUTHORIZER_LIST,
  REQUEST_SERVICE_TICKET_DETAIL,
  RECEIVE_SERVICE_TICKET_DETAIL,
  REQUEST_FETCH_TICKET_STEPS,
  RECEIVE_FETCH_TICKET_STEPS,
  REQUEST_RM_LIST,
  RECEIVE_RM_LIST
} from "./mutation-types";

import httpclient from "../utils/httpclient";

export default {
  toggleSidebar({commit}) {
    commit(TOGGLE_SIDEBAR);
  },
  fetchInviteInfo({commit}) {
    return new Promise((resolve, reject) => {
      commit(REQUEST_INVITE_INFO);

      httpclient.get("/ServiceProvider/inviteinfo").then(resp => {
        if (resp.biz_code === 0) {
          commit(RECEIVE_INVITE_INFO, resp.data);
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchSpInfo({commit, state}, spId) {
    return new Promise((resolve, reject) => {
      commit(REQUEST_SP_INFO);

      const effectiveSpId = (spId === undefined || spId === null) ? (state.user && state.user.sp_id) : spId;
      if (!effectiveSpId) {
        showError("服务商ID未初始化，请刷新页面或重新登录");
        reject(new Error("ServiceProvider id is required"));
        return;
      }
      httpclient.get("/ServiceProvider/" + effectiveSpId).then(resp => {
        if (resp.biz_code === 0) {
          commit(RECEIVE_SP_INFO, resp.data);
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  saveSpInfo({commit}, spInfo) {
    commit(REQUEST_SAVE_SP_INFO);

    httpclient.post("/ServiceProvider", spInfo).then(resp => {
      if (resp.biz_code === 0) {
        commit(RECEIVE_SAVE_SP_INFO, spInfo);
        showSuccess("保存成功");
      } else {
        showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
      }
    });
  },
  updateInfoName({commit}, payload) {
    commit(UPDATE_INFO_NAME, payload);
  },
  updateInfoContactor({commit}, payload) {
    commit(UPDATE_INFO_CONTACTOR, payload);
  },
  updateWeChatAppId({commit}, payload) {
    commit(UPDATE_WECHAT_APP_ID, payload);
  },
  updateWeChatAppSecret({commit}, payload) {
    commit(UPDATE_WECHAT_APP_SECRET, payload);
  },
  updateWeChatEncodingAesKey({commit}, payload) {
    commit(UPDATE_WECHAT_ENCODING_AES_KEY, payload);
  },
  fetchWeChatInfo({commit}) {
    commit(REQUEST_WECHAT_INFO);

    httpclient.get("/wechataccount").then(resp => {
      if (resp.biz_code === 0) {
        commit(RECEIVE_WECHAT_INFO, resp.data);
      } else {
        showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
      }
    });
  },
  saveWeChatInfo({commit}, payload) {
    return new Promise((resolve, reject) => {
      commit(REQUEST_SAVE_WECHAT_INFO);

      httpclient.post("/wechataccount", payload).then(resp => {
        if (resp.biz_code === 0) {
          commit(RECEIVE_SAVE_WECHAT_INFO, resp.data);
          showSuccess("保存成功");
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  requestClearWeChatSetting({commit}) {
    return new Promise((resolve, reject) => {
      commit(REQUEST_WECHAT_CLEAR_SETTING);

      httpclient.post("/wechataccount/clear").then(resp => {
        if (resp.biz_code === 0) {
          commit(RECEIVE_WECHAT_CLEAR_SETTING);
          showSuccess("以清除微信配置信息");
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  saveFormInfo({commit}, payload) {
    return new Promise((resolve, reject) => {
      commit(REQUEST_SAVE_FORM_INFO);

      httpclient.post("/repairform", payload).then(resp => {
        if (resp.biz_code === 0) {
          commit(RECEIVE_SAVE_FORM_INFO, resp.data);
          showSuccess("保存成功");
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  useShareForm({commit}, payload) {
    return new Promise((resolve, reject) => {
      commit(REQUEST_SAVE_FORM_INFO);

      httpclient
        .post(`/repairform/share/${payload.share_form_id}/use`, payload)
        .then(resp => {
          if (resp.biz_code === 0) {
            commit(RECEIVE_SAVE_FORM_INFO, resp.data);
            showSuccess("保存成功");
            resolve(resp);
          } else {
            showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
            reject(resp);
          }
        });
    });
  },
  requestFormList({commit}, payload) {
    return new Promise((resolve, reject) => {
      commit(REQUEST_FORM_LIST);

      httpclient
        .get("/repairform", {
          params: payload,
          paramsSerializer: params => {
            return qs.stringify(params, {arrayFormat: "repeat"});
          }
        })
        .then(resp => {
          if (resp.biz_code === 0) {
            commit(RECEIVE_FORM_LIST, resp.data);
            resolve(resp);
          } else {
            showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
            reject(resp);
          }
        });
    });
  },
  requestSharedFormList({commit}, payload) {
    return new Promise((resolve, reject) => {
      commit(REQUEST_SHARED_FORM_LIST);

      httpclient
        .get("/repairform/share", {
          params: payload,
          paramsSerializer: params => {
            return qs.stringify(params, {arrayFormat: "repeat"});
          }
        })
        .then(resp => {
          if (resp.biz_code === 0) {
            commit(RECEIVE_SHARED_FORM_LIST, resp.data);
            resolve(resp);
          } else {
            showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
            reject(resp);
          }
        });
    });
  },
  setDefaultForm({commit}, formId) {
    return new Promise((resolve, reject) => {
      httpclient.post("/repairform/" + formId + "/use").then(resp => {
        if (resp.biz_code === 0) {
          showSuccess("已设置为默认表单");
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  setFormSharable({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient
        .post(`/repairform/share/${payload.formId}/stat/${payload.share}`)
        .then(resp => {
          if (resp.biz_code === 0) {
            showSuccess(payload.share ? "表单已设置为共享" : "表单已取消共享");
            resolve(resp);
          } else {
            showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
            reject(resp);
          }
        });
    });
  },
  setFormVisible({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient
        .post(`/repairform/visible/${payload.formId}/stat/${payload.visible}`)
        .then(resp => {
          if (resp.biz_code === 0) {
            showSuccess(payload.visible ? "表单已设置为在移动端显示" : "表单已在移动端隐藏");
            resolve(resp);
          } else {
            showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
            reject(resp);
          }
        });
    });
  },
  deleteForm({commit}, formId) {
    return new Promise((resolve, reject) => {
      httpclient.post("/repairform/" + formId + "/delete").then(resp => {
        if (resp.biz_code === 0) {
          showSuccess("删除成功");
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  previewForm({commit}, formId) {
    return new Promise((resolve, reject) => {
      httpclient.get("/repairform/" + formId + "/preview").then(resp => {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchFormInfo({commit}, formId) {
    return new Promise((resolve, reject) => {
      commit(REQUEST_FORM_INFO);

      httpclient.get("/repairform/" + formId).then(resp => {
        if (resp.biz_code === 0) {
          commit(RECEIVE_FORM_INFO, resp.data);
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchDefaultFormInfo({commit}) {
    commit(REQUEST_DEFAULT_FORM_INFO);

    httpclient.get("/repairform/active").then(resp => {
      if (resp.biz_code === 0) {
        commit(RECEIVE_DEFAULT_FORM_INFO, resp.data);
      } else {
        showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
      }
    });
  },
  fetchReportList({commit}, payload) {
    return new Promise((resolve, reject) => {
      commit(REQUEST_MY_TICKET_LIST);

      httpclient
        .get("/repairticket/sp/ele", {
          params: payload,
          paramsSerializer: params => {
            return qs.stringify(params, {arrayFormat: "repeat"});
          }
        })
        .then(resp => {
          if (resp.biz_code === 0) {
            commit(RECEIVE_MY_TICKET_LIST, resp.data);
            resolve(resp);
          } else {
            showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
            reject(resp);
          }
        });
    });
  },
  fetchTicketInfo({commit}, id) {
    return new Promise((resolve, reject) => {
      commit(REQUEST_TICKET_DETAIL);

      httpclient.get("/repairticket/sp/" + id).then(resp => {
        if (resp.biz_code === 0) {
          commit(RECEIVE_TICKET_DETAIL, resp.data);
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchYhlServiceTicketInfo({commit}, payload) {
    return new Promise((resolve, reject) => {
      commit(REQUEST_SERVICE_TICKET_DETAIL);

      httpclient
        .get(`/YhlCompat/fetch/${payload.spId}/i/${payload.id}/serviceticket`)
        .then(resp => {
          if (resp.biz_code === 0) {
            commit(RECEIVE_SERVICE_TICKET_DETAIL, resp.data);
            resolve(resp);
          } else {
            commit(RECEIVE_SERVICE_TICKET_DETAIL, null);
            showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
            reject(resp);
          }
        });
    });
  },
  updateTicketProgress({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient.post("/repairticket/progress", payload).then(resp => {
        if (resp.biz_code === 0) {
          showSuccess("进度保存成功");
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  updatePassword({commit}, payload) {
    return new Promise((resolve, reject) => {
      commit(REQUEST_CHANGE_PASSWORD);

      httpclient.post("/ServiceProvider/updatepwd", payload).then(resp => {
        commit(RECEIVE_CHANGE_PASSWORD);
        if (resp.biz_code === 0) {
          showSuccess("密码修改成功");
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  createWeChatMenu({commit}, payload) {
    return new Promise((resolve, reject) => {
      commit(REQUEST_CREATE_WECHAT_MENU);

      httpclient.post("/wechatmenu", payload).then(resp => {
        commit(RECEIVE_CREATE_WECHAT_MENU);
        if (resp.biz_code === 0) {
          showSuccess("微信菜单创建成功");
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchWeChatMenu({commit}) {
    return new Promise((resolve, reject) => {
      commit(REQUEST_FETCH_WECHAT_MENU);

      httpclient.get("/wechatmenu").then(resp => {
        commit(RECEIVE_FETCH_WECHAT_MENU, resp.data);
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  bindYhlTeam({commit}, payload) {
    return new Promise((resolve, reject) => {
      commit(REQUEST_BIND_YHL_TEAM);

      httpclient.post("/YhlCompat/yhlteam/bind", payload).then(resp => {
        commit(RECEIVE_BIND_YHL_TEAM);
        if (resp.biz_code === 0) {
          showSuccess("一葫芦企业绑定成功");
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  applySubDomain({commit}, payload) {
    return new Promise((resolve, reject) => {
      commit(REQUEST_APPLY_SUB_DOMAIN);

      httpclient.post("/subdomain/apply", payload).then(resp => {
        commit(RECEIVE_APPLY_SUB_DOMAIN);
        if (resp.biz_code === 0) {
          showSuccess("二级域名申请成功, 请等待审核通过");
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  applyOwnDomain({commit}, payload) {
    return new Promise((resolve, reject) => {
      commit(REQUEST_APPLY_SUB_DOMAIN);

      httpclient.post("/owndomain/apply", payload).then(resp => {
        commit(RECEIVE_APPLY_SUB_DOMAIN);
        if (resp.biz_code === 0) {
          showSuccess("二级域名申请成功, 请等待审核通过");
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchSubDomainList({commit}, payload) {
    return new Promise((resolve, reject) => {
      commit(REQUEST_SUBDOMAIN_LIST);

      httpclient
        .get("/subdomain", {
          params: payload,
          paramsSerializer: params => {
            return qs.stringify(params, {arrayFormat: "repeat"});
          }
        })
        .then(resp => {
          if (resp.biz_code === 0) {
            commit(RECEIVE_SUBDOMAIN_LIST, resp.data);
            resolve(resp);
          } else {
            showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
            reject(resp);
          }
        });
    });
  },
  auditSubDomain({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient.post(`subdomain/${payload.id}/pass`, payload).then(resp => {
        if (resp.biz_code === 0) {
          showSuccess("二级域名申请已通过");
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  rejectSubDomain({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient.post(`subdomain/${payload.id}/reject`, payload).then(resp => {
        if (resp.biz_code === 0) {
          showSuccess("二级域名申请已驳回");
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchOwnDomainList({commit}, payload) {
    return new Promise((resolve, reject) => {
      commit(REQUEST_SUBDOMAIN_LIST);

      httpclient
        .get("/owndomain", {
          params: payload,
          paramsSerializer: params => {
            return qs.stringify(params, {arrayFormat: "repeat"});
          }
        })
        .then(resp => {
          if (resp.biz_code === 0) {
            commit(RECEIVE_SUBDOMAIN_LIST, resp.data);
            resolve(resp);
          } else {
            showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
            reject(resp);
          }
        });
    });
  },
  auditOwnDomain({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient.post(`owndomain/${payload.id}/pass`, payload).then(resp => {
        if (resp.biz_code === 0) {
          showSuccess("域名申请已通过");
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  rejectOwnDomain({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient.post(`owndomain/${payload.id}/reject`, payload).then(resp => {
        if (resp.biz_code === 0) {
          showSuccess("域名申请已驳回");
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchAccountInfo({commit}) {
    return new Promise((resolve, reject) => {
      commit(REQUEST_ACCOUNT_INFO);

      httpclient.get("/ServiceProvider/account").then(resp => {
        if (resp.biz_code === 0) {
          commit(RECEIVE_ACCOUNT_INFO, resp.data);
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  renew({commit}, payload) {
    return new Promise((resolve, reject) => {
      commit(REQUEST_ACCOUNT_RENEW);

      httpclient.post("/ServiceProvider/account/renew", payload).then(resp => {
        if (resp.biz_code === 0) {
          commit(RECEIVE_ACCOUNT_RENEW, resp.data);
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchOrderInfo({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient.get(`/ServiceProvider/account/${payload}/state`).then(resp => {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  upgrade({commit}, payload) {
    return new Promise((resolve, reject) => {
      commit(REQUEST_ACCOUNT_RENEW);

      httpclient
        .post("/ServiceProvider/account/upgrade", payload)
        .then(resp => {
          if (resp.biz_code === 0) {
            commit(RECEIVE_ACCOUNT_RENEW, resp.data);
            resolve(resp);
          } else {
            showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
            reject(resp);
          }
        });
    });
  },
  fetchAccountSzList({commit}, payload) {
    return new Promise((resolve, reject) => {
      commit(REQUEST_ACCOUNT_SZ_LIST);

      httpclient
        .get("/serviceprovider/account/list", {
          params: payload,
          paramsSerializer: params => {
            return qs.stringify(params, {arrayFormat: "repeat"});
          }
        })
        .then(resp => {
          if (resp.biz_code === 0) {
            commit(RECEIVE_ACCOUNT_SZ_LIST, resp.data);
            resolve(resp);
          } else {
            showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
            reject(resp);
          }
        });
    });
  },
  fetchAllAccountList({commit}, payload) {
    return new Promise((resolve, reject) => {
      commit(REQUEST_ACCOUNT_SZ_LIST);

      httpclient
        .get("/serviceprovider/account/list/all", {
          params: payload,
          paramsSerializer: params => {
            return qs.stringify(params, {arrayFormat: "repeat"});
          }
        })
        .then(resp => {
          if (resp.biz_code === 0) {
            commit(RECEIVE_ACCOUNT_SZ_LIST, resp.data);
            resolve(resp);
          } else {
            showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
            reject(resp);
          }
        });
    });
  },
  forceAccountRecordComplete({commit}, payload) {
    return new Promise((resolve, reject) => {
      commit(REQUEST_ACCOUNT_SZ_LIST);

      httpclient
        .post(`/serviceprovider/account/${payload.id}/complete`, payload)
        .then(resp => {
          if (resp.biz_code === 0) {
            resolve(resp);
          } else {
            showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
            reject(resp);
          }
        });
    });
  },
  fetchSpList({commit}, payload) {
    return new Promise((resolve, reject) => {
      commit(REQUEST_SP_LIST);

      httpclient
        .get("/serviceprovider", {
          params: payload,
          paramsSerializer: params => {
            return qs.stringify(params, {arrayFormat: "repeat"});
          }
        })
        .then(resp => {
          if (resp.biz_code === 0) {
            commit(RECEIVE_SP_LIST, resp.data);
            resolve(resp);
          } else {
            showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
            reject(resp);
          }
        });
    });
  },
  setSpBalance({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient
        .post(`/serviceprovider/${payload.id}/balance`, payload)
        .then(resp => {
          if (resp.biz_code === 0) {
            resolve(resp);
            showSuccess("保存成功");
          } else {
            showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
            reject(resp);
          }
        });
    });
  },
  setSpSpec({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient
        .post(`/serviceprovider/${payload.id}/spec`, payload)
        .then(resp => {
          if (resp.biz_code === 0) {
            resolve(resp);
            showSuccess("保存成功");
          } else {
            showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
            reject(resp);
          }
        });
    });
  },
  unBindYhlTeam({commit}, payload) {
    return new Promise((resolve, reject) => {
      commit(REQUEST_BIND_YHL_TEAM);

      httpclient.post("/YhlCompat/yhlteam/unbind/" + payload).then(resp => {
        commit(RECEIVE_BIND_YHL_TEAM);
        if (resp.biz_code === 0) {
          showSuccess("一葫芦企业解绑成功");
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchSpSetting({commit}) {
    return new Promise((resolve, reject) => {
      commit(REQUEST_SP_SETTING);

      httpclient.get("/ServiceProvider/setting").then(resp => {
        if (resp.biz_code === 0) {
          commit(RECEIVE_SP_SETTING, resp.data);
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  saveSpSetting({commit}, spInfo) {
    commit(REQUEST_SAVE_SP_SETTING);

    httpclient.post("/ServiceProvider/setting", spInfo).then(resp => {
      if (resp.biz_code === 0) {
        commit(RECEIVE_SAVE_SP_SETTING, spInfo);
        showSuccess("保存成功");
      } else {
        showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
      }
    });
  },
  fetchAuthorizerList({commit}, payload) {
    return new Promise((resolve, reject) => {
      commit(REQUEST_FETCH_AUTHORIZER_LIST);

      httpclient.get(`/wechatthirdparty/query/${payload.type}`).then(resp => {
        if (resp.biz_code === 0) {
          commit(RECEIVE_FETCH_AUTHORIZER_LIST, resp.data);
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  unbindAuthorizer({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient
        .post(`/wechatthirdparty/authorizer/${payload}/unbind`)
        .then(resp => {
          if (resp.biz_code === 0) {
            resolve(resp);
          } else {
            showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
            reject(resp);
          }
        });
    });
  },
  fetchWeChatThirdPartyMenu({commit}, payload) {
    return new Promise((resolve, reject) => {
      commit(REQUEST_FETCH_WECHAT_MENU);

      httpclient.get(`/wechatthirdpartymenu/${payload}`).then(resp => {
        commit(RECEIVE_FETCH_WECHAT_MENU, resp.data);
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  createWeChatThirdPartyMenu({commit}, payload) {
    return new Promise((resolve, reject) => {
      commit(REQUEST_CREATE_WECHAT_MENU);

      httpclient
        .post(`/wechatthirdpartymenu/${payload.authorizer_id}`, payload)
        .then(resp => {
          commit(RECEIVE_CREATE_WECHAT_MENU);
          if (resp.biz_code === 0) {
            showSuccess("微信授权订阅号菜单创建成功");
            resolve(resp);
          } else {
            showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
            reject(resp);
          }
        });
    });
  },
  getWeChatThirdPartyMenuUrl({commit}, payload) {
    return new Promise((resolve, reject) => {
      commit(REQUEST_CREATE_WECHAT_MENU);

      httpclient
        .post(`/wechatthirdpartymenu/${payload.authorizer_id}/single_menu_url`, payload)
        .then(resp => {
          commit(RECEIVE_CREATE_WECHAT_MENU);
          if (resp.biz_code === 0) {
            resolve(resp);
          } else {
            showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
            reject(resp);
          }
        });
    });
  },
  fetchTicketSteps({commit}, payload) {
    return new Promise((resolve, reject) => {
      commit(REQUEST_FETCH_TICKET_STEPS);

      httpclient
        .get(`/repairticket/sp/${payload.ticketId}/steps`)
        .then(resp => {
          commit(RECEIVE_FETCH_TICKET_STEPS, resp.data);
          if (resp.biz_code === 0) {
            resolve(resp);
          } else {
            showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
            reject(resp);
          }
        });
    });
  },
  fetchRatePointRemarks({commit}) {
    return new Promise((resolve, reject) => {
      httpclient.get(`/rate/point/remark`).then(resp => {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  updateRatePointRemarks({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient.post(`/rate/point/remark`, payload).then(resp => {
        if (resp.biz_code === 0) {
          showSuccess("保存成功");
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchRateTags({commit}) {
    return new Promise((resolve, reject) => {
      httpclient.get(`/rate/tags`).then(resp => {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchAutoRateSetting({commit}) {
    return new Promise((resolve, reject) => {
      httpclient.get(`/rate/point/auto/setting`).then(resp => {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  saveAutoRateSetting({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient.post(`/rate/point/auto/setting`, payload).then(resp => {
        if (resp.biz_code === 0) {
          showSuccess("自动评价设置保存成功");
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  createRateTag({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient.post(`/rate/tags`, payload).then(resp => {
        if (resp.biz_code === 0) {
          showSuccess("评价标签保存成功");
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  removeRateTag({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient.post(`/rate/tags/${payload.tagId}/remove`).then(resp => {
        if (resp.biz_code === 0) {
          showSuccess("评价标签已删除");
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  getTicketRateInfo({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient.get(`/rate/point/${payload.ticketId}`).then(resp => {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  checkTicketCanRate({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient.get(`/rate/point/check/${payload.ticketId}`).then(resp => {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchMiniApps({commit}) {
    return new Promise((resolve, reject) => {
      httpclient.get(`/WeChatThirdParty/miniapp/mgr/query`).then(resp => {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchMiniAppTesters({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient
        .get(`/WeChatThirdParty/miniapp/mgr/tester/${payload}`)
        .then(resp => {
          if (resp.biz_code === 0) {
            resolve(resp);
          } else {
            showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
            reject(resp);
          }
        });
    });
  },
  bindMiniAppTester({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient
        .post(
          `/WeChatThirdParty/miniapp/mgr/tester/${payload.authorizerId}/${payload.wechatId}/bind`
        )
        .then(resp => {
          if (resp.biz_code === 0) {
            showSuccess("绑定成功");
            resolve(resp);
          } else {
            showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
            reject(resp);
          }
        });
    });
  },
  unbindMiniAppTester({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient
        .post(
          `/WeChatThirdParty/miniapp/mgr/tester/${payload.authorizerId}/${payload.wechatId}/unbind`
        )
        .then(resp => {
          if (resp.biz_code === 0) {
            showSuccess("解除绑定成功");
            resolve(resp);
          } else {
            showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
            reject(resp);
          }
        });
    });
  },
  fetchMiniAppTemplateLists({commit}) {
    return new Promise((resolve, reject) => {
      httpclient
        .get(`/WeChatThirdParty/miniapp/mgr/template_list`)
        .then(resp => {
          if (resp.biz_code === 0) {
            resolve(resp);
          } else {
            showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
            reject(resp);
          }
        });
    });
  },
  commitMiniApp({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient
        .post(
          `/WeChatThirdParty/miniapp/mgr/${payload.authorizer_id}/commit`,
          payload
        )
        .then(resp => {
          if (resp.biz_code === 0) {
            showSuccess("小程序代码上传成功");
            resolve(resp);
          } else {
            showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
            reject(resp);
          }
        });
    });
  },
  getMiniAppTestQrCode({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient
        .get(`/WeChatThirdParty/miniapp/mgr/${payload}/qrcode/test`)
        .then(resp => {
          if (resp.biz_code === 0) {
            resolve(resp);
          } else {
            showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
            reject(resp);
          }
        });
    });
  },
  setMiniAppSupportVersion({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient
        .post(
          `/WeChatThirdParty/miniapp/mgr/${payload.authorizerId}/support_version/${payload.version}`,
          payload
        )
        .then(resp => {
          if (resp.biz_code === 0) {
            showSuccess("设置最低基础库成功");
            resolve(resp);
          } else {
            showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
            reject(resp);
          }
        });
    });
  },
  fetchMiniAppPageLists({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient
        .get(`/WeChatThirdParty/miniapp/mgr/${payload}/page_list`)
        .then(resp => {
          if (resp.biz_code === 0) {
            resolve(resp);
          } else {
            showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
            reject(resp);
          }
        });
    });
  },
  fetchMiniAppCategoryLists({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient
        .get(`/WeChatThirdParty/miniapp/mgr/${payload}/category_list`)
        .then(resp => {
          if (resp.biz_code === 0) {
            resolve(resp);
          } else {
            showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
            reject(resp);
          }
        });
    });
  },
  submitAuditMiniApp({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient
        .post(
          `/WeChatThirdParty/miniapp/mgr/${payload.authorizer_id}/submit_audit`,
          payload
        )
        .then(resp => {
          if (resp.biz_code === 0) {
            showSuccess(`小程序已提交审核`);
            resolve(resp);
          } else {
            showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
            reject(resp);
          }
        });
    });
  },
  fetchMiniAppAuditStatus({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient
        .get(`/WeChatThirdParty/miniapp/mgr/${payload}/audit_status`)
        .then(resp => {
          if (resp.biz_code === 0) {
            resolve(resp);
          } else {
            showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
            reject(resp);
          }
        });
    });
  },
  releaseMiniApp({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient
        .post(`/WeChatThirdParty/miniapp/mgr/${payload}/release`, payload)
        .then(resp => {
          if (resp.biz_code === 0) {
            showSuccess(`小程序已发布`);
            resolve(resp);
          } else {
            showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
            reject(resp);
          }
        });
    });
  },
  setMiniAppSearchable({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient
        .post(
          `/WeChatThirdParty/miniapp/mgr/${payload.authorizer_id}/search_status/${payload.searchable}`
        )
        .then(resp => {
          if (resp.biz_code === 0) {
            showSuccess(`小程序可搜索状态已设置`);
            resolve(resp);
          } else {
            showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
            reject(resp);
          }
        });
    });
  },
  fetchMiniAppSearchable({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient
        .get(`/WeChatThirdParty/miniapp/mgr/${payload}/search_status`)
        .then(resp => {
          if (resp.biz_code === 0) {
            resolve(resp);
          } else {
            showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
            reject(resp);
          }
        });
    });
  },
  setMiniAppVisitable({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient
        .post(
          `/WeChatThirdParty/miniapp/mgr/${payload.authorizer_id}/search_status/${payload.visible}`
        )
        .then(resp => {
          if (resp.biz_code === 0) {
            showSuccess(`小程序可见状态已设置`);
            resolve(resp);
          } else {
            showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
            reject(resp);
          }
        });
    });
  },
  revertMiniApp({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient
        .post(`/WeChatThirdParty/miniapp/mgr/${payload}/revert`, payload)
        .then(resp => {
          if (resp.biz_code === 0) {
            showSuccess(`小程序发布版本已回退`);
            resolve(resp);
          } else {
            showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
            reject(resp);
          }
        });
    });
  },
  revokeAuditMiniApp({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient
        .post(`/WeChatThirdParty/miniapp/mgr/${payload}/revoke_audit`, payload)
        .then(resp => {
          if (resp.biz_code === 0) {
            showSuccess(`小程序已撤回审核`);
            resolve(resp);
          } else {
            showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
            reject(resp);
          }
        });
    });
  },
  getTicketGeoInfo({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient.get(`/RepairTicket/sp/${payload.ticketId}/geo`).then(resp => {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  updateAuthorizerInfo({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient
        .post(`/WeChatThirdParty/authorizer/${payload.id}`, payload)
        .then(resp => {
          if (resp.biz_code === 0) {
            showSuccess(`公众号信息已保存`);
            resolve(resp);
          } else {
            showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
            reject(resp);
          }
        });
    });
  },
  fetchRmList({commit}, payload) {
    return new Promise((resolve, reject) => {
      commit(REQUEST_RM_LIST);

      httpclient
        .get("/repairmember", {
          params: payload,
          paramsSerializer: params => {
            return qs.stringify(params, {arrayFormat: "repeat"});
          }
        })
        .then(resp => {
          if (resp.biz_code === 0) {
            commit(RECEIVE_RM_LIST, resp.data);
            resolve(resp);
          } else {
            showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
            reject(resp);
          }
        });
    });
  },
  fetchWeChatThirdPartyComponentLoginUrl({commit}) {
    return new Promise((resolve, reject) => {
      httpclient.get(`/WeChatThirdParty/componentloginurl`).then(resp => {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  setRmVerified({commit}, payload) {
    const {id} = payload;
    return new Promise((resolve, reject) => {
      httpclient.post(`/repairmember/${id}/verify`).then(resp => {
        if (resp.biz_code === 0) {
          showSuccess(`已审核报修会员`);
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  setRmUnVerified({commit}, payload) {
    const {id} = payload;
    return new Promise((resolve, reject) => {
      httpclient.post(`/repairmember/${id}/unverify`).then(resp => {
        if (resp.biz_code === 0) {
          showSuccess(`报修会员已设置未审核`);
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  deleteRm({commit}, payload) {
    const {id} = payload;
    return new Promise((resolve, reject) => {
      httpclient.post(`/repairmember/${id}/delete`).then(resp => {
        if (resp.biz_code === 0) {
          showSuccess(`报修会员已删除`);
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  reSyncTicket({commit}, ticketId) {
    return new Promise((resolve, reject) => {
      httpclient.post(`/repairticket/sp/${ticketId}/resync`).then(resp => {
        if (resp.biz_code === 0) {
          showSuccess(`报修单已重新同步`);
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchWeChatReplySetting({commit}) {
    return new Promise((resolve, reject) => {
      httpclient.get(`/WeChatAccount/subscribe_reply`).then(resp => {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchWeChatThirdPartyReplySetting({commit}, id) {
    return new Promise((resolve, reject) => {
      httpclient.get(`/WeChatThirdParty/${id}/subscribe_reply`).then(resp => {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  updateWeChatReplySetting({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient.post(`/WeChatAccount/subscribe_reply`, payload).then(resp => {
        if (resp.biz_code === 0) {
          showSuccess(`公众号关注回复信息已保存`);
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  updateWeChatThirdPartyReplySetting({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient
        .post(`/WeChatThirdParty/${payload.id}/subscribe_reply`, payload)
        .then(resp => {
          if (resp.biz_code === 0) {
            showSuccess(`公众号关注回复信息已保存`);
            resolve(resp);
          } else {
            showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
            reject(resp);
          }
        });
    });
  },
  fetchDevFormSetting({commit}, id) {
    return new Promise((resolve, reject) => {
      httpclient.get(`/YhlDeviceAsset/sp/${id}/form_setting`).then(resp => {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  updateDevFormSetting({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient.post(`/YhlDeviceAsset/form_setting`, payload).then(resp => {
        if (resp.biz_code === 0) {
          resolve(resp);
          showSuccess("保存成功");
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  deleteTicket({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient.post(`/repairticket/sp/${payload.id}/delete`).then(resp => {
        if (resp.biz_code === 0) {
          resolve(resp);
          showSuccess("以删除报修单");
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  batchDeleteTickets({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient.post(`/repairticket/sp/batchdelete`, payload).then(resp => {
        if (resp.biz_code === 0) {
          resolve(resp);
          showSuccess("已删除报修单");
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  compileApp({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient.post(`/app/compile`, payload).then(resp => {
        if (resp.biz_code === 0) {
          resolve(resp);
          showSuccess("已提交发布请求");
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchAppCompiles({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient
        .get("/app", {
          params: payload,
          paramsSerializer: params => {
            return qs.stringify(params, {arrayFormat: "repeat"});
          }
        })
        .then(resp => {
          if (resp.biz_code === 0) {
            resolve(resp);
          } else {
            showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
            reject(resp);
          }
        });
    });
  },
  fetchLatestApp({commit}, spId) {
    return new Promise((resolve, reject) => {
      httpclient.get(`/app/${spId}/latest`).then(resp => {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  fetchFeedbacks({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient
        .get(`/feedback/`, {
          params: payload,
          paramsSerializer: params => {
            return qs.stringify(params, {arrayFormat: "repeat"});
          }
        })
        .then(resp => {
          if (resp.biz_code === 0) {
            resolve(resp);
          } else {
            showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
            reject(resp);
          }
        });
    });
  },
  fetchFeedbackDetail({commit}, id) {
    return new Promise((resolve, reject) => {
      httpclient.get(`/feedback/${id}`).then(resp => {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  processFeedback({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient.post(`/feedback/${payload.id}/process`, payload).then(resp => {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  getMiniAppPrivacySetting({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient
        .get(`/WeChatThirdParty/miniapp/mgr/${payload.authorizer_id}/privacy`, {
          params: {privacy_ver: payload.privacy_ver},
          paramsSerializer: params => {
            return qs.stringify(params, {arrayFormat: "repeat"});
          }
        })
        .then(resp => {
          if (resp.biz_code === 0) {
            resolve(resp);
          } else {
            showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
            reject(resp);
          }
        });
    });
  },
  setMiniAppPrivacySetting({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient.post(`/WeChatThirdParty/miniapp/mgr/${payload.authorizer_id}/privacy`, payload.setting).then(resp => {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
  updateAuthorizerDomain({commit}, payload) {
    return new Promise((resolve, reject) => {
      httpclient.post(`/WeChatThirdParty/miniapp/mgr/${payload.authorizer_id}/update_domain`).then(resp => {
        if (resp.biz_code === 0) {
          resolve(resp);
        } else {
          showError(resp.biz_message || "处理您的请求时发生错误, 请重试");
          reject(resp);
        }
      });
    });
  },
};



// WEBPACK FOOTER //
// ./src/store/actions.js